class ShareList {
    constructor(el) {
        this.shareList = el;
        this.shareButtons = document.querySelectorAll('.js-share');
        this.attachListeners();
    }

    attachListeners() {
        this.shareButtons.forEach(shareButton => {
            shareButton.addEventListener('click', () => this.toggleShareList());
        });
    }

    toggleShareList() {
        this.shareList.classList.toggle('-open');
    }
}

export default el => new ShareList(el);
